export class ItemSubFamily {
    public itemSubFamilyId: number;
    public name: string;
    public itemFamilyId: number;
    public companyId: number;

    public searchFamily:any;
    public lstFamily=[];
    public lstFamilyFiltradas:any;
}


// WEBPACK FOOTER //
// ./src/app/models/item-subfamily.ts